/* eslint-disable prettier/prettier */
import axios from "axios";

import { ContactsOutlined } from "@material-ui/icons";
import {
  reLoginValidation,
  loginValidation,
  empty,
  forgotValidation,
  resetValidation,
} from "./validation";
import fetchConfig from "../Constants/fetch";
import errorMessages from "../Constants/ErrorMessages";
import { encrypt, decrypt } from "./encrypt";

const { paths: axiosPaths, url: urlConstants } = fetchConfig; // TODO: write cleaner
// TODO: handle a middle name, for example 'John Joseph Doe' will
// result as 'JJD' instead of 'JD'
export const getFullNameAbbreviation = (fullName) => {
  let nameArray = fullName.split(" ");
  nameArray = nameArray.map((current) => current.charAt(0));

  const Abbreviation =
    nameArray.length >= 2 ? nameArray.join("") : nameArray[0];

  return Abbreviation.toUpperCase();
};

/**
    @param { Object } userData - The data the user provided in the login
    @param { String } userData.email -  The email of the user from the login
    @param { String } userData.password - the password of the user from the login

    The userData object will be passed in the following format:
        {
            email: email@email.com,
        }
*/

// TODO: Need to refactor this function, the return of the errors is inconsistent
export const sendUserLoginData = async (userData, gameEventId) => {
  // User input validation
  const { error: validationError } = loginValidation.validate(userData);
  if (validationError) {
    return {
      errorCode: validationError,
      errorMessage: errorMessages.VALIDATION,
    };
  }

  // remember to change it to correct url
  let fetchResult;
  if (!gameEventId || gameEventId == 0) {
    fetchResult = await axios.get(
      `${fetchConfig.prefix}/auth/login_email`, {
      params: {
        email: userData.Email,
        password: userData.encPassword,
        account: userData.accountValue,
        event: gameEventId,
        instructor: userData.instructor,
      }
    }
    );
  }
  else {
    fetchResult = await axios.get(`${fetchConfig.prefix}/auth/event_login_email`, {
      params: {
        email: userData.Email,
        password: userData.encPassword,
        account: userData.accountValue,
        event: gameEventId,
        instructor: userData.instructor,
      }
    }
    );
  }
  return fetchResult.data;
};

/**
    @param { Object } userData - The data the user provided in the login
    @param { String } userData.email -  The email of the user from the login

    The userData object will be passed in the following format:
        {
            email: email@email.com,
        }
*/

// TODO: Need to refactor this function, the return of the errors is inconsistent
// @DEPRECATED: this function is no longer used and maintained. it is to be removed
export const sendUserReLoginData = async (userData) => {
  // User input validation
  const { error: validationError } = reLoginValidation.validate(userData);
  if (validationError) {
    return {
      errorCode: validationError,
      errorMessage: errorMessages.VALIDATION,
    };
  }
  const params = {
    email: userData.Email,
  };
  // remember to change it to correct url
  const fetchResult = await axios.get(
    `${fetchConfig.prefix}/auth/relogin_email?email=${params.email}`
  );

  return fetchResult.data;
};

/**
 *  @param { Object } userData - The parameter that we want from the URL
 *  @param { String } userData.Email - The email that we want from the URL
 */
export const forgotPass = async (userData) => {
  const { error: validationError } = forgotValidation.validate(userData);
  if (validationError) {
    return {
      errorCode: validationError,
      errorMessage: errorMessages.VALIDATION,
    };
  }
  const fetchResult = await axios.post(
    `${fetchConfig.prefix}/auth/password-reset/request`,
    { email: userData.Email, language: userData.Language }
  );
  return fetchResult.data;
};


/**
 * Check if a previous unfinished game exists for user
 *  @param { Integer } userId - The userId
 */
export const checkRestoreGame = async (userId) => {
  const data = {
    userId,
  };
  const fetchResult = await axios.post(
    `${fetchConfig.prefix}/auth/checkRestoreGame`,
    data
  );
  // const fetchResult = {
  //     result: false,
  //     gameId: -1,
  // };

  return fetchResult.data;
};

/**
 * create new game for user if checkRestoreGame is false
 *  @param { Integer } userId - The userId
 */
export const createNewGame = async (userId, gameEventId, creationDateTime, accountId, instructorId, forceNewGame = false) => {
  const data = {
    userId, gameEventId, creationDateTime, accountId, instructorId, forceNewGame
  };

  const fetchResult = await axios.post(
    `${fetchConfig.prefix}/auth/createNewGame`,
    data
  );
  return fetchResult.data; // Return full response instead of just gameId
};

/**
 *  @param { String } param - The parameter that we want from the URL
 */
const getUrlParam = (param) => {
  if (empty(param)) {
    return false;
  }
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(param);
};

/**
 *  @param { String } fetchCode - The code from axios that we will check
 */
const assertFetchStatusServerError = (fetchCode) => {
  const errorCodes = ["500", "403"];

  return errorCodes.includes(`${fetchCode}`);
};

export const filterTasksFromData = (response) => {
  const firstFilterStage = Object.entries(response).filter(
    (element) => element[0].includes("task") && response[element[0]]
  );

  return firstFilterStage.map((element) => element[1]);
};

export const filterRelationshipsFromData = (task) => {
  const firstFilterStage = Object.entries(task).filter(
    (element) => element[0].includes("relationships") && task[element[0]]
  );

  return firstFilterStage.map((element) => element[1]);
};

/**
 * @param { String } xStart - The x coordinate of the start point
 * @param { String } yStart - The y coordinate of the start point
 * @param { String } xEnd - The x coordinate of the end point
 * @param { String } yEnd - The y coordinate of the end point
 */
export const progressAnimationCoords = (movingDirection) => {
  const directions = {
    top: {
      xEnd: 0,
      yEnd: -18,
    },
    right: {
      xEnd: 10,
      yEnd: 0,
    },
    left: {
      xEnd: -10,
      yEnd: 0,
    },
    bottom: {
      xEnd: 0,
      yEnd: 18,
    },
  };

  const prevYend = +getComputedStyle(document.documentElement)
    .getPropertyValue("--progress-end-top")
    .trim()
    .replace("vh", "");
  const prevXend = +getComputedStyle(document.documentElement)
    .getPropertyValue("--progress-end-right")
    .trim()
    .replace("vw", "");

  document.documentElement.style.setProperty(
    "--progress-end-top",
    `${directions[movingDirection].yEnd + prevYend}vh`
  );
  document.documentElement.style.setProperty(
    "--progress-end-right",
    `${directions[movingDirection].xEnd + prevXend}vw`
  );
};

export const checkDirection = (tileId) => {
  switch ((tileId + 1) % 8) {
    default:
    case 0:
    case 1:
    case 4:
    case 5:
      return "top";
    case 2:
    case 3:
      return "right";
    case 6:
    case 7:
      return "left";
  }
};

export const checkReverseDirection = (tileId) => {
  switch (tileId % 8) {
    default:
    case 0:
    case 1:
    case 4:
    case 5:
      return "bottom";
    case 6:
    case 7:
      return "right";
    case 2:
    case 3:
      return "left";
  }
};

export const logSummary = (logArray) => {
  const translationCodeToAction = {
    0: "empty",
    1: "empty",
    2: "Planned",
    3: "Unplanned",
    4: "Risk",
    5: "Constraint",
    6: "Delay",
    8: "Milestone",
    21: "Gate", // change to 21.
    11: "General",
  };
  const result = {
    Planned: 0,
    Unplanned: 0,
    Risk: 0,
    Constraint: 0,
    Delay: 0,
    Milestone: 0,
    Gate: 0,
    General: 0,
  };
  // if (translationCodeToAction[element.code]) {
  logArray.map((element) => {
    if (element.turnData) {
      if (translationCodeToAction[element.turnData.code]) {
        if (translationCodeToAction[element.turnData.code] == "empty") {
          // console.log('if');
          // eslint-disable-next-line no-unused-expressions
          result[translationCodeToAction[element.turnData.code]];
        } else {
          result[translationCodeToAction[element.turnData.code]]++;
          if (element.turnData.code === 6 && element.turnData.value === "7" && element.turnData.decision === 1) { // player got the redo delay, and he clicked on the redo task.
            result.Planned--;
          }
        }
      }
    }
  });
  return result;
};


// log codes:
// 0 - turn start
// 1 - arranged project
// 2 - planned task
// 3 - unplanned task
// 4 - risk
// 5 - constraint
// 6 - delay
// 7 - additional funds
// 8 - milestone
// 9 - gate
// 10 - change resources
// 11 - general task
// 19 - resource bought details.
